import { useLayoutEffect } from 'react';

const useWindowHeight = () => {
  useLayoutEffect(() => {
    const doc = document.documentElement;
    let lastHeaderHeight = null;
    let lastFullVh = null;

    const getZoom = () => {
      const wrapper = document.getElementById('zoom-wrapper');
      return wrapper && wrapper.style.zoom ? parseFloat(wrapper.style.zoom) || 1 : 1;
    };

    const updateHeaderHeight = () => {
      const header = document.querySelector('.header');
      if (!header) return;
      const zoom = getZoom();
      // Force sync layout flush so getBoundingClientRect reflects latest CSS.
      const height = Math.round(header.getBoundingClientRect().height / zoom);
      if (height === lastHeaderHeight) return;
      lastHeaderHeight = height;
      doc.style.setProperty('--header-height', `${height}px`);
      // Guard: dispatching resize only when height actually changed prevents loops.
      window.dispatchEvent(new Event('resize'));
    };

    const update = () => {
      const zoom = getZoom();
      const fullVh = window.innerHeight / zoom / 100;
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
      doc.style.setProperty('--full-vh', `${fullVh}px`);
      // Notify Leaflet when --full-vh changes (e.g. zoom toggle, orientation change).
      // Guard against loops: only dispatch when value actually changed.
      if (fullVh !== lastFullVh) {
        lastFullVh = fullVh;
        window.dispatchEvent(new Event('resize'));
      }
      updateHeaderHeight();
    };

    // ResizeObserver catches header growing after logo/font loads post-mount.
    let headerObserver;
    const header = document.querySelector('.header');
    if (header && window.ResizeObserver) {
      headerObserver = new ResizeObserver(updateHeaderHeight);
      headerObserver.observe(header);
    }

    // iOS fires orientationchange before innerHeight updates — delay by one frame.
    const onOrientationChange = () => requestAnimationFrame(update);
    const onResize = () => requestAnimationFrame(update);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onOrientationChange);
    update();

    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onOrientationChange);
      if (headerObserver) headerObserver.disconnect();
    };
  }, []);

  return null;
};

export default useWindowHeight;
